import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { MockOfficeActionHeaderService } from './services/impls/mock-office-action-header-service';
import { OfficeActionHeaderService } from './services/office-action-header-service';
import { OarTaskService, BaseOarTaskService } from './services/oar-task-service';
import { OarTaskApi } from './apis/oar-task-api';
import { OarTaskDataLoader } from './loaders/oar-task-data-loader';
import { OarTaskDataOrchestrator } from './services/oar-task-data-orchestrator';
import { OarTaskContentModel } from './models/oar-task-content-model';
import { ClaimAnalysisResultModel } from './models/claim-analysis-result-model';
import { OarStatementContentModel } from './models/oar-statement-content-model';
import { OarCacheService } from './services/oar-cache-service';
import { ExportStatementApi } from './apis/export-statement-api';
import { PreviewStatementPromptApi } from './apis/preview-statement-prompt-api';
import { GenerateStatementOpinionApi } from './apis/generate-statement-opinion-api';
import { ComparisonPageTaskApi } from './apis/comparison-page-task-api';
import { CachedOarCacheServiceImpl } from './services/impls/cached-oar-cache-service';
import { CachedOarTaskService } from './services/impls/cached-oar-task-service';
import { DefaultOarTaskDataOrchestrator } from './services/impls/default-oar-task-data-orchestrator';
import { DefaultOarTaskService } from './services/impls/default-oar-task-service';
import { OarTaskContentModelImpl } from './models/impls/oar-task-content-model-impl';
import { ClaimAnalysisResultModelImpl } from './models/impls/claim-analysis-result-model-impl';
import { OarStatementContentModelImpl } from './models/impls/oar-statement-content-model-impl';
import { BodyDataLoader } from './loaders/impls/body-data-loader';
import { HeaderDataLoader } from './loaders/impls/header-data-loader';
import { TableDataLoader } from './loaders/impls/table-data-loader';
import { TaskInfoLoader } from './loaders/impls/task-info-loader';
import { OarTaskApiImpl } from './apis/impls/oar-task-api-impl';
import { ClaimAnalysisCommandFactory } from './commands/claim-analysis-command';
import { ClaimAnalysisCommandFactoryImpl } from './commands/impls/claim-analysis-command-factory-impl';
import { StatementOpinionAsyncApi } from './apis/statement-opinion-async-api';

export function oarModule(bind: interfaces.Bind) {
    // Models
    bind(OarTaskContentModel).to(OarTaskContentModelImpl);
    bind(ClaimAnalysisResultModel).to(ClaimAnalysisResultModelImpl);
    bind(OarStatementContentModel).to(OarStatementContentModelImpl);

    // Services
    bind(OfficeActionHeaderService).to(MockOfficeActionHeaderService);

    // Command Factory
    bind(ClaimAnalysisCommandFactory).to(ClaimAnalysisCommandFactoryImpl);

    // OAR Task Service - 缓存配置
    // 基础实现（供缓存装饰器使用）
    bind(BaseOarTaskService).to(DefaultOarTaskService);
    // 缓存服务
    bind(OarCacheService).to(CachedOarCacheServiceImpl);
    // bind(OarTaskService).to(MockOarTaskService);
    // 带缓存的任务服务（公共接口）
    // bind(OarTaskService).to(CachedOarTaskService);
    // 如果不需要缓存，可以直接使用：
    bind(OarTaskService).to(DefaultOarTaskService);

    // APIs
    bind(OarTaskApiImpl).toSelf();
    bind(OarTaskApi).toService(OarTaskApiImpl);
    bind(ExportStatementApi).toService(OarTaskApiImpl);
    bind(PreviewStatementPromptApi).toService(OarTaskApiImpl);
    bind(GenerateStatementOpinionApi).toService(OarTaskApiImpl);
    bind(ComparisonPageTaskApi).toService(OarTaskApiImpl);
    bind(StatementOpinionAsyncApi).toService(OarTaskApiImpl);

    // Data Loaders (使用 multiInject 模式)
    bind(OarTaskDataLoader).to(TaskInfoLoader);
    bind(OarTaskDataLoader).to(HeaderDataLoader);
    bind(OarTaskDataLoader).to(TableDataLoader);
    bind(OarTaskDataLoader).to(BodyDataLoader);

    // Data Orchestrator
    bind(OarTaskDataOrchestrator).to(DefaultOarTaskDataOrchestrator).inSingletonScope();
}
